import { AxiosError, AxiosResponse } from 'axios'

import { getAppURL } from '@/shared/utils/electron'
import { FetchResponse, useFetchApi } from '@/shared/utils/fetch'

import { QueueService } from '../types'

const API_PATH = '/api/user/queue-services'

export const useQueueServiceApi = () => {
  const useFetch = useFetchApi()

  return {
    async getQueueServices (): Promise<AxiosResponse<QueueService[]> | FetchResponse<QueueService[]>> {
      try {
        return await useFetch.get(getAppURL({ pathName: API_PATH }))
      } catch (e) {
        const status = (e as AxiosError)?.response?.status
          ?? (e as { status?: number })?.status
        // Endpoint may be absent on some tenants; treat as empty and allow later retries
        // (e.g. after queues are provisioned mid-session — settings beforeEnter / next fetchAll).
        if (status === 404) {
          return { data: [], status: 404, statusText: 'Not Found', headers: {}, config: {} as never }
        }
        throw e
      }
    },
    patchQueueServices (
      queues: QueueService[],
    ): Promise<AxiosResponse<QueueService[]> | FetchResponse<QueueService[]>> {
      return useFetch.patch(getAppURL({ pathName: API_PATH }), queues)
    },
  }
}
